import GoogleIcon from "@/components/logos/GoogleIcon";
import TelegramIcon from "@/components/logos/TelegramIcon";
import { Spinner } from "@heroui/spinner";

import DiscordIcon from "@/components/logos/DiscordIcon";
import LoginLinks from "./LoginLinks";
import RecoveryKeyModal from "./RecoveryKeyModal";
import TelegramLoginLink from "./TelegramLoginLink";

type LoginPageContentProps = {
  isGoogleLoading: boolean;
  initiateGoogleLogin: (referral?: string) => void;
  isDiscordLoading: boolean;
  initiateDiscordLogin: (referral?: string) => void;
  isTelegramLoading: boolean;
  recoveryKey?: string | null;
  onRecoveryKeyContinue?: () => void;
  ref?: string;
};

const LoginPageContent = ({
  initiateGoogleLogin,
  isTelegramLoading,
  isGoogleLoading,
  isDiscordLoading,
  initiateDiscordLogin,
  recoveryKey,
  onRecoveryKeyContinue,
  ref,
}: LoginPageContentProps) => {
  return (
    <div className="relative min-h-screen w-screen bg-[#0B0B11]">
      <img
        alt="bg-visual"
        src="/images/login_bg.webp"
        className="absolute left-0 top-0 z-0 hidden h-full object-cover object-left md:block"
      />
      <section className="flex min-h-screen w-screen flex-col items-center justify-center overflow-hidden pb-[32px] md:pb-[47px]">
        <main className="z-10 flex w-full max-w-[95vw] flex-col items-center gap-5 px-4 md:max-w-[600px] md:gap-7 md:px-0">
          <img
            alt="Logo"
            src="/logos/app_logo.svg"
            width={160}
            height={45}
            className="mb-2 mt-2 md:h-[73px] md:w-[261px]"
          />
          <h1 className="mt-[-2px] text-center font-alliance text-2xl font-medium leading-[1.2] text-white md:text-[35px]">
            {"trade like nobody's watching"}
          </h1>
          <p className="mb-2 max-w-[90vw] text-center font-inter text-sm font-medium leading-[1.21] text-[#686F83] md:max-w-[270px] md:text-[16px]">
            Connect to start trading instantly
          </p>
          <div className="mb-3 flex w-full flex-col justify-center gap-2 md:flex-row">
            <LoginButton
              isLoading={isGoogleLoading}
              onClick={() => initiateGoogleLogin(ref ?? undefined)}
            >
              <GoogleIcon className="mr-2 size-5 md:size-6" />
              <span className="font-alliance text-base font-semibold md:text-[18px]">
                Google
              </span>
            </LoginButton>
            <TelegramLoginLink ref={ref}>
              <LoginButton isLoading={isTelegramLoading} onClick={() => {}}>
                <TelegramIcon className="mr-2 size-5 md:size-6" />
                <span className="font-alliance text-base font-semibold md:text-[18px]">
                  Telegram
                </span>
              </LoginButton>
            </TelegramLoginLink>
            <LoginButton
              isLoading={isDiscordLoading}
              onClick={() => initiateDiscordLogin(ref ?? undefined)}
            >
              <DiscordIcon className="mr-2 size-5 md:size-6" />
              <span className="font-alliance text-base font-semibold md:text-[18px]">
                Discord
              </span>
            </LoginButton>
          </div>
          <LoginLinks />
          <RecoveryKeyModal
            open={recoveryKey !== undefined}
            onOpenChange={() => {}}
            recoveryKey={recoveryKey ?? ""}
            onContinue={onRecoveryKeyContinue}
          />
        </main>
      </section>
    </div>
  );
};

type LoginButtonProps = {
  onClick: () => void;
  isLoading: boolean;
  children: React.ReactNode;
};

const LoginButton = (props: LoginButtonProps) => {
  const base =
    "flex h-12 w-full md:h-[86px] md:w-[180px] flex-row items-center justify-center gap-3 rounded-[18px] md:rounded-[25px] transition-colors bg-[#1F1F2B] hover:bg-[#2D2D3D]";

  return (
    <button className={base} disabled={props.isLoading} onClick={props.onClick}>
      {props.isLoading ? (
        <Spinner color="white" size="md" />
      ) : (
        <div className="flex items-center gap-3">{props.children}</div>
      )}
    </button>
  );
};

export default LoginPageContent;
